module.exports = __webpack_public_path__ + "img/phantom-assasin.262c7891.jpg";